import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FaCalendarCheck, FaEdit } from "react-icons/fa";
import { AuthenticationService } from '../services/authentication.service';
import * as Constants from '../constants';
import { FaCheckToSlot } from "react-icons/fa6";

export default function useColumnsHabitacion(togglePop, togglePopValida, guardarSelectedHabitacion) {

	const [t] = useTranslation("global");
	
	const authenticationService = new AuthenticationService();
	const userRol = authenticationService.getAuthenticationSession().user.idTipo;//obtiene el rol del usuario
	const userTipoEmpleado = authenticationService.getAuthenticationSession().user.tipoEmpleado;

	const onEditarHabitacion = (habitacion) => {
		guardarSelectedHabitacion(habitacion);
		togglePop();
	}
 
	const onValidarHabitacion = (habitacion) => {
		guardarSelectedHabitacion(habitacion);
		togglePopValida();
	}

	const columns = useMemo(() => {
		const baseColumns = [
			{
				Header: t("app.establecimiento.table.numero"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-negro-columna">{row.original.numero}</p>
					</div>
				)
			},
			{
				Header: t("app.establecimiento.table.edificio"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.edificio}</p>
					</div>
				)
			},
			{
				Header: t("app.establecimiento.table.planta"),
				Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.planta}</p>
					</div>
				)
			},
			{
				Header: t("app.habitacion.estado"),
				Cell: ({ row }) => (
					<div>
						{row.original.estadoHabitacion.id === Constants.ESTADO_HABITACION_NO_OCUPADA ?
							<div className="dotTableValueStyle">
								<span className="dotNoOcupada"></span><p className="letra-grisClaro-columna">{row.original.estadoHabitacion.estado}</p>
							</div>
							: row.original.estadoHabitacion.id === Constants.ESTADO_HABITACION_LIMPIAR ?
							<div className="dotTableValueStyle">
								<span className="dotLimpiar"></span><p className="letra-grisClaro-columna">{row.original.estadoHabitacion.estado}</p>
							</div> 
							: row.original.estadoHabitacion.id === Constants.ESTADO_HABITACION_SALIDA ?
							<div className="dotTableValueStyle">
								<span className="dotSalida"></span><p className="letra-grisClaro-columna">{row.original.estadoHabitacion.estado}</p>
							</div>
							: null
						}
					</div>
				)
			},
			{
				Header: t("app.popup.label.terminada"),
				accessor: "terminada",
				Cell: ({ row }) => (
					<div>
						{row.original.validada ?<p className="letra-grisClaro-columna">{t("app.habitacion.validada")}</p>
							:row.original.terminada ?<p className="letra-grisClaro-columna">{t("app.habitacion.terminada")}</p> 
							:<p className="letra-grisClaro-columna">{t("app.label.no")}</p>
						}
					</div>
				),
			}
		];
		
		if (userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado != null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA
			|| userRol === Constants.ROLE_USUARIO_GESTOR) {
			baseColumns.push(
				{
					Header: t("app.popup.label.asignadaA"),
					accessor: "nombreUsuario",
					Cell: ({ row }) => (
						<div>
							{row.original.nombreUsuario ? <p className="letra-grisClaro-columna">{row.original.nombreUsuario} {row.original.apellidosUsuario}</p> : <p className="letra-grisClaro-columna">{t("app.popup.label.sinAsignar")}</p>}
						</div>
					),
				}
			);			
		}
		
		baseColumns.push(
			{
				accessor: 'action',
				Cell: ({ row }) => (
					<div className={'container-actionsTabla'}>
						<button className={'button-actionRecord'} onClick={(e) => onEditarHabitacion(row.original, e)}><FaEdit size='20' className={'icon-button-editarRecord'}/></button>
					</div>
				),
			}
		);
		
		if (userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado != null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA
			|| userRol === Constants.ROLE_USUARIO_GESTOR) {
		
			baseColumns.push(
				{
					accessor: 'validar',
					Cell: ({ row }) => (
						<div className={'container-actionsTabla'}>
							{row.original.validada ? null : <button className={'button-actionRecord'} onClick={(e) => onValidarHabitacion(row.original, e)}><FaCheckToSlot size='20' className={'icon-button-editarRecord'}/></button>}
						</div>
					),
				}
			);
		}
		return baseColumns;
	}, [t, userRol]);

	return columns;
}